import React from 'react';
import styled from 'styled-components';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>The University of Texas at Dallas - Graduate Students in Physics</p>
      </div>
    </footer>
  );
};

export default Footer;
